import React, { useEffect, useRef, useState } from 'react';
import './job-list.scss';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Job from './types/job';

export type Properties = {
  className?: string;
  itemClassName?: string;
  withImage?: boolean;
  jobs: Job[];
  Card: React.ComponentType<{ job: Job }>;
};

const JobList = ({ className, itemClassName, withImage = false, jobs, Card }: Properties) => {
  const [showCard, setShowCard] = useState(true);
  const [focussed, setFocussed] = useState<string>();
  const [doFocus, setDoFocus] = useState<boolean>(false);
  const reference = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const nextAnchorElement = reference.current?.nextElementSibling?.querySelector('a');
    if (doFocus && nextAnchorElement) {
      nextAnchorElement.focus();
      setDoFocus(false);
    }
  }, [focussed, reference.current, doFocus, jobs.length]);

  const rememberFocus = (event: React.FocusEvent<HTMLLIElement>, job: Job) => {
    setFocussed(job.id);
    const nextAnchor = event.currentTarget.nextElementSibling?.querySelector('a');
    setDoFocus(!nextAnchor);
  };

  return (
    <TransitionGroup
      component="ul"
      className={`dvinci-job-list list-unstyled ${typeof className === 'undefined' ? '' : className}`}
      aria-live="polite"
    >
      {jobs.map((job) => (
        <CSSTransition
          key={job.id.toString()}
          in={showCard}
          timeout={250}
          classNames={{
            enter: 'dvinci-enter',
            enterActive: 'dvinci-enter-active',
            exit: 'dvinci-exit',
            exitActive: 'dvinci-exit-active',
          }}
          unmountOnExit
          onEnter={() => setShowCard(false)}
          onExited={() => setShowCard(true)}
        >
          <li
            key={job.id}
            onFocus={(event) => rememberFocus(event, job)}
            ref={focussed === job.id ? reference : undefined}
          >
            <Card
              // @ts-ignore
              className={itemClassName}
              withImage={withImage}
              job={job}
            />
          </li>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
};

export default JobList;
